export function setNavigationLang(state) {
  let lang;
  switch (state) {
    case 'ar': {
      lang = 'العربية';
      break;
    }
    case 'se-NO':
    case 'no-NO':
    case 'no': {
      lang = 'Norwegian';
      break;
    }
    case 'da-GL':
    case 'da-DK':
    case 'da': {
      lang = 'Danish';
      break;
    }
    case 'mm':
    case 'my-MM': {
      lang = 'Burmese';
      break;
    }
    case 'ms-SG':
    case 'ms-BN':
    case 'ms-MY':
    case 'my': {
      lang = 'Bahasa Melayu';
      break;
    }
    case 'sv-FI':
    case 'sv-SE':
    case 'se':
    case 'sv': {
      lang = 'Swedish';
      break;
    }
    case 'sr-SP':
    case 'sr-BA':
    case 'sr': {
      lang = 'Serbian';
      break;
    }
    case 'mz': {
      lang = 'Portuguese';
      break;
    }
    default:
      lang = 'العربية';
    // eslint-disable-next-line no-unreachable
  }

  return lang;
}

export function changeLocalesMyMm(lang) {
  let switchLocale;
  switch (lang) {
    case 'mm':
    case 'my-MM': {
      switchLocale = 'my';
      break;
    }
    case 'ms-SG':
    case 'ms-BN':
    case 'ms-MY':
    case 'my': {
      switchLocale = 'ms-my';
      break;
    }
    default:
      switchLocale = lang;
    // eslint-disable-next-line no-unreachable
  }

  return switchLocale;
}
